var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.27 5.293a.97.97 0 0 1 0 1.414L7.77 11h12.144c.578 0 1.048.448 1.048 1s-.47 1-1.049 1H7.772l4.499 4.293a.97.97 0 0 1 0 1.414c-.41.39-1.073.39-1.482 0l-6.289-6A.98.98 0 0 1 4.192 12c0-.265.11-.52.307-.707l6.289-6c.41-.39 1.073-.39 1.482 0"
  })));
};
export default SvgArrowLeft;